export default __webpack_public_path__ + "static/media/base-plaque.e0183e22.png";